import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"
import { getAnalytics } from "firebase/analytics"
import { getStorage } from "firebase/storage"

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCHnckPsewc9UORkqDiXa92iWO-WHEkiqg",
  authDomain: "iiche-avvu-sc.firebaseapp.com",
  projectId: "iiche-avvu-sc",
  storageBucket: "iiche-avvu-sc.firebasestorage.app",
  messagingSenderId: "1092777123582",
  appId: "1:1092777123582:web:e6d60424dccd462620cfaf",
  measurementId: "G-7WCGZLWP2M",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize services
export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)

// Initialize Analytics only in production and browser environment
let analytics = null
if (typeof window !== "undefined" && process.env.NODE_ENV === "production") {
  try {
    analytics = getAnalytics(app)
  } catch (error) {
    console.warn("Analytics initialization failed:", error)
  }
}
export { analytics }

// Add connection state logging
console.log("Firebase initialized successfully")
console.log("Project ID:", firebaseConfig.projectId)
console.log("Auth Domain:", firebaseConfig.authDomain)

export default app
